import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";
const fetchUpdateUser = (userData) => {
  return api.put(`/user/${userData._id}`, userData);
};

export const useUpdateUserQuery = () => {
  return useMutation({ mutationFn: fetchUpdateUser });
};
